<template>
  <div class="page-wrap requests-page">
    <div class="requests-shell">
      <section class="requests-hero glass">
        <div class="requests-hero__main">
          <div class="requests-hero__eyebrow">История</div>
          <h1>Мои брони</h1>
          <p>Активные и завершённые бронирования.</p>
        </div>

        <!--<div class="requests-hero__stats">
          <div class="requests-stat">
            <span>Активные</span>
            <strong>{{ activeCount }}</strong>
          </div>
          <div class="requests-stat">
            <span>История</span>
            <strong>{{ historyCount }}</strong>
          </div>
          <div class="requests-stat requests-stat--accent">
            <span>Всего</span>
            <strong>{{ allCount }}</strong>
          </div>
        </div>-->
      </section>

      <BaseCard class="requests-panel">
        <div class="requests-toolbar">
          <div class="requests-tabs" aria-label="Фильтр броней">
            <button
              v-for="tab in tabs"
              :key="tab.key"
              type="button"
              :class="{ active: activeTab === tab.key }"
              @click="activeTab = tab.key"
            >
              <span class="requests-tabs__label">{{ tab.label }}</span>
              <span class="requests-tabs__count">{{ tabCount(tab.key) }}</span>
            </button>
          </div>

          <div v-if="isAdmin" class="requests-filters">
            <BaseInput v-model="filters.status" type="select" aria-label="Статус">
              <option value="">Все статусы</option>
              <option value="created">Создана</option>
              <option value="confirmed">Подтверждена</option>
              <option value="in_progress">В процессе</option>
              <option value="completed">Завершена</option>
              <option value="cancelled">Отменена</option>
            </BaseInput>
            <BaseInput v-model="filters.booking_date" type="date" aria-label="Дата брони" />
          </div>
        </div>

        <div v-if="loadingList && !items.length" class="requests-loading glass">
          Загружаю брони...
        </div>

        <div v-else-if="filteredItems.length" class="requests-list">
          <router-link
            v-for="item in filteredItems"
            :key="item.order_number"
            :to="`/requests/${item.order_number}`"
            class="request-card"
            :class="`request-card--${requestTone(item.status)}`"
          >
            <div class="request-card__marker"></div>

            <div class="request-card__body">
              <div class="request-card__top">
                <div class="request-card__title-wrap">
                  <span class="request-card__number">{{ prettyOrderNumber(item.order_number) }}</span>
                  <strong class="request-card__title">{{ primaryTitle(item) }}</strong>
                </div>

                <StatusBadge :status="item.status" />
              </div>

              <div class="request-card__meta">
                <span class="request-card__meta-item">
                  <BaseIcon name="home" />
                  {{ item.club_name || 'Клуб' }}
                </span>
                <span class="request-card__meta-item">
                  <BaseIcon name="calendar" />
                  {{ formatDate(item.booking_date) }}
                </span>
                <span class="request-card__meta-item">
                  <BaseIcon name="clock" />
                  {{ timeRange(item) }}
                </span>
                <span class="request-card__meta-item">
                  <BaseIcon name="wallet" />
                  {{ paymentLabel(item) }}
                </span>
              </div>
            </div>

            <div class="request-card__side">
              <strong>{{ formatPrice(item.total_price || 0) }}</strong>
              <span>Подробнее</span>
            </div>
          </router-link>
        </div>

        <div v-else class="empty-state glass">
          <div class="empty-state__icon">
            <BaseIcon name="ticket" />
          </div>
          <div>
            <strong>{{ emptyTitle }}</strong>
            <p>{{ emptyText }}</p>
          </div>
        </div>

        <BaseButton
          v-if="hasMore"
          class="requests-more"
          variant="secondary"
          block
          :loading="loadingList"
          @click="loadMore"
        >
          Загрузить ещё
        </BaseButton>
      </BaseCard>
    </div>
  </div>
</template>

<script>
import BaseButton from '../components/ui/BaseButton.vue';
import BaseCard from '../components/ui/BaseCard.vue';
import BaseIcon from '../components/ui/BaseIcon.vue';
import BaseInput from '../components/ui/BaseInput.vue';
import StatusBadge from '../components/ui/StatusBadge.vue';
import { formatDate, formatPrice, formatTime, paymentMeta } from '../utils/formatters';

const ACTIVE_STATUSES = ['created', 'confirmed', 'in_progress'];
const HISTORY_STATUSES = ['completed', 'cancelled', 'no_show', 'rejected'];

export default {
  name: 'RequestsView',
  components: {
    BaseButton,
    BaseCard,
    BaseIcon,
    BaseInput,
    StatusBadge,
  },
  data() {
    return {
      activeTab: 'active',
      tabs: [
        { key: 'active', label: 'Активные' },
        { key: 'history', label: 'История' },
        { key: 'all', label: 'Все' },
      ],
      filters: {
        status: '',
        booking_date: '',
      },
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    items() {
      return this.$store.getters['orders/items'];
    },
    hasMore() {
      return this.$store.getters['orders/hasMore'];
    },
    loadingList() {
      return this.$store.getters['orders/loadingList'];
    },
    activeCount() {
      return this.items.filter((item) => ACTIVE_STATUSES.includes(item.status)).length;
    },
    historyCount() {
      return this.items.filter((item) => HISTORY_STATUSES.includes(item.status)).length;
    },
    allCount() {
      return this.items.length;
    },
    filteredItems() {
      let items = [...this.items];

      if (this.activeTab === 'active') {
        items = items.filter((item) => ACTIVE_STATUSES.includes(item.status));
      } else if (this.activeTab === 'history') {
        items = items.filter((item) => HISTORY_STATUSES.includes(item.status));
      }

      if (this.filters.status) {
        items = items.filter((item) => item.status === this.filters.status);
      }

      if (this.filters.booking_date) {
        items = items.filter((item) => item.booking_date === this.filters.booking_date);
      }

      return items;
    },
    emptyTitle() {
      if (this.activeTab === 'history') return 'История пока пустая';
      if (this.activeTab === 'all') return 'Броней пока нет';
      return 'Активных броней нет';
    },
    emptyText() {
      if (this.activeTab === 'history') {
        return 'Когда бронирование завершится или отменится, оно появится здесь.';
      }

      return `Создай первую бронь в ${this.brandName}, и она сразу появится в этом списке.`;
    },
  },
  async mounted() {
    await this.$store.dispatch('orders/loadOrders', { reset: true });
  },
  methods: {
    formatDate,
    formatPrice,
    formatTime,
    tabCount(key) {
      if (key === 'active') return this.activeCount;
      if (key === 'history') return this.historyCount;
      return this.allCount;
    },
    prettyOrderNumber(orderNumber) {
      const raw = String(orderNumber || '').trim();
      if (!raw) return '#—';

      const match = raw.match(/(\d{4,})$/);
      return match ? `#${match[1]}` : raw;
    },
    primaryTitle(item) {
      return item.seat_label || item.booking_type || 'Бронь';
    },
    timeRange(item) {
      const start = this.formatTime(item.start_time);
      const end = item.end_time ? this.formatTime(item.end_time) : '';

      return end ? `${start}–${end}` : start;
    },
    paymentLabel(item) {
      return item.payment_status_label || paymentMeta(item.payment_status);
    },
    requestTone(status) {
      const normalized = String(status || '').toLowerCase();

      if (['confirmed', 'accepted'].includes(normalized)) return 'success';
      if (normalized === 'in_progress') return 'warning';
      if (['cancelled', 'no_show', 'rejected'].includes(normalized)) return 'danger';
      if (normalized === 'completed') return 'neutral';

      return 'pending';
    },
    async loadMore() {
      await this.$store.dispatch('orders/loadOrders', { filters: this.filters });
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (this.isAdmin) {
          this.$store.dispatch('orders/loadOrders', { reset: true, filters: this.filters });
        }
      },
    },
  },
};
</script>

<style scoped src="./RequestsView.css"></style>